import React, { useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import {
  H3,
  FlexBox,
  SquareFlexBox,
  ClickableBox,
  SpacingBox,
} from '../Components';
import AppContext from '../AppContext';
import styles from './TischOffensives.module.scss';
import { getTischOffensivesForCurrentUser } from '../selectors';
import { getTranslateByScope } from '../i18n';

const translate = getTranslateByScope('app.tischOffensives');

const TISCH_OFFENSIVE_SQUARE_SIZE = 96;
const TischOffensiveCard = ({ id, description }) => (
  <SquareFlexBox
    style={{
      borderRadius: '3px',
      backgroundImage: `url("https://assets-crm.schoeffel.de/public/images/sales_packages/${id}.jpg")`,
      backgroundPosition: 'center center',
      backgroundSize: 'cover',
      boxShadow: '4px 4px 4px rgba(0,0,0,0.1)',
    }}
    className={styles.card}
    size={TISCH_OFFENSIVE_SQUARE_SIZE}
    flexDirection="flex-end"
    margin="xs">
    <FlexBox paddingLeft="xs" flex={0.8} alignItems="flex-end">
      <p
        style={{
          fontSize: '13px',
          fontWeight: 'bold',
          color: 'white',
          textShadow: 'black 1px 1px 4px',
        }}>
        {description}
      </p>
    </FlexBox>
  </SquareFlexBox>
);

export const TischOffensives = withRouter(({ history, onSelect }) => {
  const context = useContext(AppContext);

  const tischOffensives = getTischOffensivesForCurrentUser(context);

  if (!_.values(tischOffensives)) return null;

  const tischOffensiveCards = _.values(tischOffensives).map((t) => {
    if (!t.id) return null;

    const handleClick = () => {
      onSelect();
      history.push(`/productList?tischOffensiveId=${t.id}`);
    };
    return (
      <ClickableBox key={`cb${t.id}`} onClick={handleClick}>
        <TischOffensiveCard key={t.id} id={t.id} description={t.description} />
      </ClickableBox>
    );
  });
  return (
    <SpacingBox>
      <SpacingBox marginTop="lg" marginBottom="md">
        <H3>{translate('salestools')}</H3>
      </SpacingBox>
      <FlexBox style={{ maxWidth: 800 }} flexDirection="row" flexWrap="wrap">
        {tischOffensiveCards}
      </FlexBox>
    </SpacingBox>
  );
});

export default TischOffensives;
